import { render, staticRenderFns } from "./depositWithdrawalPoint.vue?vue&type=template&id=2a06b80e&"
import script from "./depositWithdrawalPoint.vue?vue&type=script&lang=js&"
export * from "./depositWithdrawalPoint.vue?vue&type=script&lang=js&"
import style0 from "./depositWithdrawalPoint.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports